var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paper-simple',{staticClass:"d-md-flex mt-2"},[_c('sidebar',{attrs:{"tab":_vm.activeTab},on:{"activeTab":_vm.changeActiveTab}}),_c('div',{key:_vm.layout,staticClass:"w-100 mt-2"},[_c(_vm.layout,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }